import { observer } from 'mobx-react-lite'
import { type ConfirmUserTransactionDialogViewModel } from '@/features/payouts/admin/review/ConfirmUserTransactionDialogViewModel'
import { formatTransactionReason } from '@/features/payouts/transaction-formatters'
import { ConfirmNewTransactionModal } from '@/features/payouts/admin/review/components/ConfirmNewTransactionModal'

export interface ConfirmNewTransactionModalContainerProps {
  vm: ConfirmUserTransactionDialogViewModel
}

export const ConfirmNewTransactionModalContainer = observer(
  function ConfirmNewTransactionModalContainer({
    vm,
  }: ConfirmNewTransactionModalContainerProps) {
    return (
      <ConfirmNewTransactionModal
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onConfirm={vm.confirm}
        reasonLabel={formatTransactionReason(vm.reason)}
        recipientName={vm.recipient.displayName}
        amount={vm.amount}
      />
    )
  },
)
